<template>
  <v-app>
    <AppNavbar />
    <SnackbarQueue class="mt-2 mb-2" />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useLocale } from 'vuetify';
import AppNavbar from '@/components/Navbar.vue';
import SnackbarQueue from '@/components/common/SnackbarQueue.vue';

export default defineComponent({
  name: 'App',
  components: {
    AppNavbar,
    SnackbarQueue,
  },
  setup() {
    const { locale } = useI18n()
    const vuetifyLocale = useLocale()

    watch(locale, (newLocale) => {
      vuetifyLocale.current.value = newLocale
    })
  }
})
</script>
